import { CREATESESSION_FAIL, CREATESESSION_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const createSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATESESSION_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATESESSION_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createSessionReducer;
